module.exports = __webpack_public_path__ + "static/media/times-red-icon.0323fa5b.svg";